/** HMVMAuth SSO for HMVMReviewer. */

export const HMVM_AUTH_URL = "https://auth.hmvm.ru"
export const AUTH_HOME = `${HMVM_AUTH_URL}/?service=review`
export const REVIEWER_TOKEN_KEY = "hmvm:reviewer:token"

export function takeHmvmTokenFromUrl(): string | null {
  const params = new URLSearchParams(window.location.search)
  const token = params.get("hmvm_token")?.trim() || null
  if (!token) return null
  params.delete("hmvm_token")
  const qs = params.toString()
  const next = `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`
  window.history.replaceState({}, "", next)
  return token
}

export function storeReviewerToken(token: string): void {
  localStorage.setItem(REVIEWER_TOKEN_KEY, token)
}

export function loadReviewerToken(): string | null {
  return localStorage.getItem(REVIEWER_TOKEN_KEY)
}

export function clearReviewerToken(): void {
  localStorage.removeItem(REVIEWER_TOKEN_KEY)
}

export function hmvmAuthReturnTo(): string {
  const { origin, pathname, search, hash } = window.location
  return `${origin}${pathname}${search}${hash}`
}

export function redirectToReviewAuth(): void {
  const params = new URLSearchParams({
    service: "review",
    method: "passkey",
    return_to: hmvmAuthReturnTo(),
  })
  window.location.assign(`${HMVM_AUTH_URL}/?${params.toString()}`)
}
